<template>
  <GlobalQuestionWindow
    :title="title"
    width="60%"
    top="5vh"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <Editor
      v-if="form.code"
      v-model="form.code"
      :defaultConfig="{ readOnly : true }"
    />
    <div slot="footer">
      <el-button @click="visible=false">返回</el-button>
    </div>
  </GlobalQuestionWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import { Editor } from '@wangeditor/editor-for-vue'
import GlobalQuestionWindow from '@/components/common/GlobalQuestionWindow'
export default {
  name: 'Question',
  extends: BaseOpera,
  components: { GlobalQuestionWindow, Editor },
  data () {
    return {
      content: '',
      // 表单数据
      form: {
        id: '',
        label: '',
        code: '',
      },
      type: 0, // 0 查看 1 答题
      companyId: '',
      baseForm: {},
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/system/dictData',
      'field.id': 'id'
    })
  },
  methods: {
    // /**
    //  * 打开窗口
    //  * @title 窗口标题
    //  * @target 编辑的对象
    //  */
    // open (title, target) {
    //   debugger
    //   this.title = title
    //   this.visible = true
    //   // 新建
    //   if (target == null) {
    //     this.$nextTick(() => {
    //       this.$refs.form.resetFields()
    //       this.form[this.configData['field.id']] = null
    //     })
    //     return
    //   }
    //   // 编辑
    //   this.$nextTick(() => {
    //     for (const key in this.form) {
    //       this.form[key] = target[key]
    //     }
    //   })
    // },
  },
}
</script>

<style lang="scss" scoped>
.title {
  height: 20px;
  font-size: 20px;
  font-weight: 600;
  color: #222222;
  line-height: 20px;
  text-align: center;
}
.line {
  margin: 24px 0;
  background-color: #DFE2E8;
  height: 1px;
}
.problem {
  margin-bottom: 30px;
  .problem-title {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #222222;
    line-height: 24px;
  }
}
.option {
  margin-top: 25px;
  display: flex;
  .el-radio {
    margin-right: 0px;
  }
  ::v-deep .el-radio__label {
    width: 0;
  }
  .value{
    height: 14px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
    vertical-align: middle;
  }
  .mult-value{
    height: 14px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 19px;
    margin-left: 10px;
  }
}
</style>
